
































































































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import PublicLayout from '@/views/layouts/PublicLayout.vue';
import { Product } from '@/store/types/work/product';
import Pagination from '@/components/Pagination.vue';
import { Getter } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import { PRODUCTS_REQUEST, GET_PRODUCTS } from '@/store/models/work/enterprise/products/products';
import ProductItem from '@/components/work/products/Item.vue';
import ProductEditDialog from '@/components/work/products/EditDialog.vue';
import { CATEGORIES_REQUEST } from '@/store/models/work/enterprise/products/categories';
import { CATEGORIES_REQUEST as CATEGORY_TYPES_REQUEST } from '@/store/models/pub/products/categories';
import { MEASURES_REQUEST } from '@/store/models/work/enterprise/products/measures';

@Component({
  components: { Pagination, PublicLayout, ProductItem, ProductEditDialog }
})
export default class EnterpriseProductsIndex extends Mixins<SlotMixin>(SlotMixin) {
  public page:number = 1;
  public perPage:number = 18;
  public loading: boolean = true;
  public editItem: Product|object = {};
  public showEdit: boolean = false;
  public filteredProducts:Array<Product> = [];
  public filter = {
    title: '',
    code: '',
    category: ''
  };
  public price = 0;
  public json_data:any[] = [];
  public json_fields = {
    'Назва товару': 'title',
    'Категорія': 'category_title',
    'Ціна': 'price',
    'Кількість': 'value',
    'Артикул': 'article',
    'Код': 'bar_code'
  };

  public prices () {
    return [
      { title: this.$t('product.price'), value: 0 },
      { title: this.$t('product.opt_price'), value: 1 },
      { title: this.$t('product.big_opt_price'), value: 2 }
    ];
  }

  @Watch('$route.query')
  onQueryChanged () {
    return this.$store.dispatch(PRODUCTS_REQUEST);
  }
  @Getter(GET_PRODUCTS) products!: Product[];

  @Watch('products', { deep: true })
  public onProductsChange () {
    this.filterProducts();
    this.json_data = [...this.products];
  }

  @Watch('filter', { deep: true })
  public onFilterChanged (newValue:any) {
    this.filterProducts();
  }

  filterProducts () {
    this.page = 1;
    this.loading = true;
    let products = [...this.products];
    if (this.filter.title) {
      products = products.filter((product:Product) => {
        return product.title.toLowerCase().includes(
          this.filter.title.toLowerCase()
        );
      });
    }
    if (this.filter.category) {
      products = products.filter((product:Product) => {
        return product.category_title.toLowerCase().includes(
          this.filter.category.toLowerCase()
        );
      });
    }
    if (this.filter.code) {
      products = products.filter((product:Product) => {
        return product.bar_code.join(',').includes(this.filter.code) ||
          (product.article || '').includes(this.filter.code);
      });
    }
    this.loading = false;
    this.filteredProducts = products;
  }

  public startEditForm (data:Product|object = {}) {
    this.showEdit = true;
    this.editItem = data;
  }

  public productsUpdated () {
    this.$store.dispatch(PRODUCTS_REQUEST);
    this.showEdit = false;
  }

  public created () {
    this.$store.dispatch(PRODUCTS_REQUEST);
    this.$store.dispatch(CATEGORIES_REQUEST, this.$route.params.enterprise);
    this.$store.dispatch(CATEGORY_TYPES_REQUEST);
    this.$store.dispatch(MEASURES_REQUEST);
    this.$gtag.event('page_view', {});
  }
}
